import { render, staticRenderFns } from "./TableSetting.vue?vue&type=template&id=51035aed&scoped=true"
import script from "./TableSetting.vue?vue&type=script&lang=js"
export * from "./TableSetting.vue?vue&type=script&lang=js"
import style0 from "./TableSetting.vue?vue&type=style&index=0&id=51035aed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51035aed",
  null
  
)

export default component.exports